import * as _ from 'underscore';
import { DropdownHelper, IDropdownScope } from '../helpers/DropdownHelper';
import { ISliceable } from '../models/ISliceable';
import { Module } from '../Module';
import { SliceableHelper } from '../helpers/SliceableHelper';

export interface ITextDropdownOption {
  value: string;
  translate: string;
}

interface ITextDropdownScope extends IDropdownScope<string, ITextDropdownOption> {

  // Bound to attributes
  model: string;
  optionList: ITextDropdownOption[];
  preventInput: (local: { value: string }) => any;

  // Internal
  width: number;  // Used to match drop-down width to control width
  items: ISliceable<ITextDropdownOption>;
  itemText: (item: any) => string;
}

Module.instance().directive('tbTextDropdown', [
  '$timeout',                   '$translate',
  ($timeout: ng.ITimeoutService, $translate: ng.translate.ITranslateService) => {
    return {
      restrict: 'E',
      templateUrl: 'textDropdown.html',
      replace: true,
      scope: {
        model: '=ngModel',
        optionList: '=',
        preventInput: '&tbPreventInput'
      },
      link: (scope: ITextDropdownScope, element: JQuery, attributes: ng.IAttributes) => {

        scope.items = SliceableHelper.fromArray(scope.optionList);

        const rowToModel = (option?: ITextDropdownOption): string => {
          return option ? option.value : scope.textValue;
        };

        DropdownHelper.setupDropdownScope<string, ITextDropdownOption>(scope, $timeout, element.find('input'), rowToModel);

        scope.itemText = (model: string) => {
          const option: ITextDropdownOption = _.findWhere(scope.optionList, { value: model });
          return option ? $translate.instant(option.translate) : model;
        };

        scope.$watch('editMode', (editMode: boolean) => {
          if (editMode) {
            scope.width = element.width();
          }
        });

        scope.$watch('textValue', () => scope.currentRow.index = -1);
      }
    };
  }
]);
